export enum SettingTabsModel {
  GeneralSettings,
  LicenseManagement,
  Domains,
  Subscription,
  Login
}